import { BaseCommand } from "@crunchdao/shared-cli";
import { StakingClient, formatCrunch } from "@crunchdao/sdk";
import chalk from "chalk";

export class GetRewardsCommand extends BaseCommand {
  async execute(): Promise<void> {
    try {
      const stakingClient = new StakingClient({
        connection: this.provider.connection,
        wallet: this.provider.wallet,
      });

      console.log(chalk.yellow("Calculating claimable rewards..."));

      const rewardsData = await stakingClient.getClaimableRewards();

      const totalRewardsCRNCH = formatCrunch(rewardsData.totalRewards, 8);

      if (this.resolvedOptions.output === "json") {
        this.output({
          totalRewards: rewardsData.totalRewards.toString(),
          formatted: totalRewardsCRNCH,
          expiry: rewardsData.expiry,
          simulationLogs: rewardsData.simulationLogs,
        });
      } else {
        console.log(chalk.cyan.bold("\n💰 Claimable Rewards"));
        console.log(chalk.gray("═".repeat(60)));
        console.log(`Total Rewards: ${chalk.green.bold(totalRewardsCRNCH + " CRNCH")}`);
        console.log(`Raw amount: ${chalk.gray(rewardsData.totalRewards.toString())}`);
        if (rewardsData.expiry) {
          console.log(
            `Expiry: ${chalk.yellow(new Date(Number(rewardsData.expiry) * 1000).toLocaleString())}`
          );
        }

        if (rewardsData.simulationLogs && rewardsData.simulationLogs.length > 0) {
          console.log(chalk.cyan.bold("\n📋 Simulation Logs"));
          console.log(chalk.gray("═".repeat(60)));
          rewardsData.simulationLogs.forEach((logs, index) => {
            console.log(chalk.yellow(`\nSimulation ${index + 1}:`));
            logs.forEach((log) => {
              console.log(chalk.gray(`  ${log}`));
            });
          });
        }

        console.log();
      }
    } catch (error) {
      console.error("❌ Error getting rewards:", error);
      throw error;
    }
  }
}
